import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-overlay-notifications',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './overlay-notifications.component.html',
  styleUrl: './overlay-notifications.component.scss',
})
export class OverlayNotificationsComponent {}
